module.exports = __webpack_public_path__ + "media/clef.f3f61920.webm";